let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ixwr1")).then(() => parcelRequire('cG9Gr'));